import { isApiError } from '@noor/api';

/** Delivery's global handler owns all permission-denied toasts. */
export function isDeliveryForbiddenError(error: unknown): boolean {
  const pathname = window.location.pathname;
  return (
    (pathname === '/delivery' || pathname.startsWith('/delivery/')) &&
    isApiError(error) &&
    error.status === 403
  );
}
